<template>
  <router-link
    :to="to"
    :class="[
      'group block w-full touch-manipulation border-b border-gray-100/50 px-3 py-3 text-left transition-all duration-200 last:border-b-0 sm:px-4 sm:py-3.5 dark:border-gray-800/50',
      isHighlighted
        ? `border-l-3 bg-gradient-to-r to-transparent shadow-sm dark:to-transparent ${SEARCH_PALETTE[color].highlighted}`
        : `border-l-3 border-l-transparent hover:bg-gradient-to-r hover:from-gray-50 hover:to-transparent hover:shadow-sm dark:hover:from-gray-800/50 dark:hover:to-transparent ${SEARCH_PALETTE[color].hover}`,
    ]"
    @click="$emit('click', $event)"
    @mouseenter="$emit('mouseenter')"
  >
    <div class="flex items-center gap-3">
      <div
        :class="`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br ring-1 transition-all duration-200 group-hover:scale-110 group-hover:shadow-md sm:h-11 sm:w-11 ${SEARCH_PALETTE[color].iconBox}`"
      >
        <i :class="`pi pi-${icon} text-base ${SEARCH_PALETTE[color].icon}`"></i>
      </div>
      <div class="min-w-0 flex-1">
        <div class="mb-1 truncate text-sm font-semibold text-gray-900 sm:text-base dark:text-white">
          {{ title }}
        </div>
        <div v-if="$slots.metadata" class="mt-1.5 flex flex-wrap items-center gap-2 text-xs">
          <slot name="metadata"></slot>
        </div>
      </div>
      <i
        class="pi pi-chevron-right text-xs text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 dark:text-gray-600"
      ></i>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { SEARCH_PALETTE, type SearchColor } from './searchColors';

defineProps<{
  title: string;
  icon: string;
  color: SearchColor;
  to: RouteLocationRaw;
  isHighlighted?: boolean;
}>();

defineEmits<{
  click: [event: MouseEvent];
  mouseenter: [];
}>();
</script>
